import { CustomerType } from "@origin-digital/platform-enums";
import {
  IMcAppType,
  NavFlow,
  salesCommonParameters,
  Tab,
} from "../mcApp.types";

export const salesFormAuthAddHomeResi: IMcAppType = {
  name: "salesFormAuthAddHomeResi",
  path: "/my/add-home",
  parameters: {
    properties: {
      journeyType: salesCommonParameters.journeyType,
      planFetchStrategy: salesCommonParameters.planFetchStrategy,
      fuel: salesCommonParameters.fuel,
      existingFuel: salesCommonParameters.fuel,
      originAddressId: salesCommonParameters.originAddressId,
    },
    required: [
      "journeyType",
      "planFetchStrategy",
      "fuel",
      "existingFuel",
      "originAddressId",
    ],
  },
  description: "(Internal) Sales form entry for RESI authenticated add home",
  navFlow: NavFlow.FOCUS,
  title: "Add a property",
  parent: Tab.MORE,

  conditions: {
    intent: "salesFormAuthAddHomeResi",
    customerType: CustomerType.kraken,
  },
};

// new sales form auth move for businessnavigation
export const salesFormAuthAddHomeBusiness: IMcAppType = {
  name: "salesFormAuthAddHomeBusiness",
  path: "/my/business/add-home",
  parameters: {
    properties: {
      journeyType: salesCommonParameters.journeyType,
      planFetchStrategy: salesCommonParameters.planFetchStrategy,
      fuel: salesCommonParameters.fuel,
      existingFuel: salesCommonParameters.existingFuel,
      originAddressId: salesCommonParameters.originAddressId,
    },
    required: [
      "journeyType",
      "planFetchStrategy",
      "fuel",
      "existingFuel",
      "originAddressId",
    ],
  },
  description: "(Internal) Sales form entry for SME authenticated add home",
  navFlow: NavFlow.FOCUS,
  title: "Add a property",
  parent: Tab.MORE,

  conditions: {
    intent: "salesFormAuthAddHomeBusiness",
    customerType: CustomerType.kraken,
  },
};
